export type ThemeMode = 'blue' | 'sand' | 'slate';

const STORAGE_KEY = 'mbw-theme';
const THEME_MODES: readonly ThemeMode[] = ['blue', 'sand', 'slate'];
const DEFAULT_THEME: ThemeMode = 'blue';

function isThemeMode(value: unknown): value is ThemeMode {
  return (
    typeof value === 'string' &&
    (THEME_MODES as readonly string[]).includes(value)
  );
}

export function getTheme(): ThemeMode {
  try {
    if (typeof localStorage === 'undefined') {
      return DEFAULT_THEME;
    }

    const stored = localStorage.getItem(STORAGE_KEY);
    return isThemeMode(stored) ? stored : DEFAULT_THEME;
  } catch {
    // Storage access itself can throw (blocked cookies / privacy modes) —
    // fall back to the default rather than breaking app startup.
    return DEFAULT_THEME;
  }
}

export function setTheme(mode: ThemeMode): ThemeMode {
  const next = isThemeMode(mode) ? mode : DEFAULT_THEME;

  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = next;
  }
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, next);
    }
  } catch {
    // Persistence is best-effort; the DOM theme still applies for the session.
  }

  return next;
}
